import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box, Button, Divider, Fade,
  makeStyles, Modal, Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import parse from 'html-react-parser';

import { GetCourseByUser, GetTopicById } from '../../../../services/courses';
import CanvaKoin from '../models/CanvaKoin';

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    position: 'absolute',
    left: '65%',
    top: '15%',
    zIndex: 100,
    maxWidth: 400,
    maxHeight: 420,
    borderRadius: '20px',
    border: `4px solid ${theme.palette.background.info}`,
    padding: theme.spacing(3, 3),
    background: theme.palette.background.card,
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleSede: {
    fontSize: '34px',
    fontFamily: 'Raleway',
    fontWeight: 600,
    color: theme.palette.background.info,
    margin: theme.spacing(2, 0, 1, 0),
  },
  titleTheme: {
    fontSize: '23px',
    fontFamily: 'Raleway',
    fontWeight: 600,
    textAlign: 'center',
    margin: theme.spacing(2, 0, 1, 0),
    color: theme.palette.text.default,
  },
  textTheme: {
    fontSize: '16px',
    fontFamily: 'Raleway',
    fontWeight: 500,
    textAlign: 'center',
    color: theme.palette.text.default,
  },
  divider: {
    background: theme.palette.background.default,
  },
  containerKoins: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  textKoins: {
    fontSize: '16px',
    fontFamily: 'Raleway',
    fontWeight: 500,
    textAlign: 'center',
    color: theme.palette.text.default,
  },
  button: {
    background: theme.palette.background.secondary,
    width: 200,
    textTransform: 'capitalize',
    color: theme.palette.text.default,
    fontSize: '16px',
    fontFamily: 'Raleway',
    margin: theme.spacing(2, 0),
  },
  iconClose: {
    float: 'right',
    cursor: 'pointer',
    color: theme.palette.common.white,
  },
}));

function ModalCourseInfo() {
  const classes = useStyles();
  const params = useParams();
  const { theme, idTopic, course } = params;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState('');
  const [description, setDescription] = useState('');
  const [completedSomeLesson, setCompletedSomeLesson] = useState(undefined);
  const { sub } = useSelector((store) => store.login);

  const apiGetTopicByIdAndCourseByUser = async () => {
    const topic = await GetTopicById(idTopic);
    const courseByUser = await GetCourseByUser(sub, course);
    const { topicsByUser } = courseByUser.data[0];
    const topicSelected = topicsByUser.find((e) => e.idTopic === idTopic);
    setData(topic.data);
    const descriptionTopic = `${topic.data.description.slice(0, 350)}...`;
    setDescription(descriptionTopic);
    setCompletedSomeLesson(topicSelected.lessonsByUser.find((e) => e.completedLesson === true));
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };
  const navigateStatistics = () => {
    navigate('/statistics', {
      state: {
        course,
        topic: idTopic,
      },
    });
  };
  const handleBack = () => {
    sessionStorage.setItem('noneInit', true);
    navigate(-1);
  };
  useEffect(() => {
    apiGetTopicByIdAndCourseByUser();
  }, []);
  return (
    <div>
      <Modal open hideBackdrop>
        <Fade in={!isLoading}>
          <Box className={classes.modalContainer}>
            <>
              <CloseIcon className={classes.iconClose} onClick={handleBack} />
              <Box className={classes.modalContent}>
                <Box>
                  <Typography className={classes.titleSede}>{theme}</Typography>
                  <Divider className={classes.divider} />
                </Box>
                <Typography className={classes.titleTheme}>{data.name}</Typography>
                <Typography className={classes.textTheme}>
                  {parse(description)}
                </Typography>
                <Box className={classes.containerKoins}>
                  <CanvaKoin widthValue={50} heightValue={60} />
                  <Typography className={classes.textKoins}>{`${data.koins} koins`}</Typography>
                </Box>
                <Button color="secondary" variant="contained" className={classes.button} onClick={navigateStatistics}>
                  {completedSomeLesson === undefined ? 'INICIAR' : 'CONTINUAR'}
                </Button>
              </Box>
            </>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default ModalCourseInfo;
